const translations = {
    account: 'Acct',
    air: 'Air',
    chemicals: 'Chem',
    connections: 'Conn',
    data: 'Data',
    help: 'Help',
    home: 'Home',
    maint: 'Maint',
    reports: 'Reps'
};

export default translations;
